import { useCallback } from 'react';
import { type DeliveryOrderDetail } from '@sg/graphql-schema';

import { type OrderingContext } from '@order/features/ordering';

import { usePlacedOrdersCounter } from '../../../../context/PlacedOrdersCounter';
import { type PartialLineItem } from '../../../../graphql';
import { useLocalOrderHistory } from '../../../../hooks';

export const usePostOrderHistory = () => {
  const { incrementPlacedOrdersCounter } = usePlacedOrdersCounter();
  const { addToLocalOrderHistory } = useLocalOrderHistory();

  const handlePostOrderHistory = useCallback(
    (context: OrderingContext<PartialLineItem, DeliveryOrderDetail>) => {
      const { orderId } = context;

      if (!orderId) return;

      addToLocalOrderHistory({ orderId });
      incrementPlacedOrdersCounter();
    },
    [addToLocalOrderHistory, incrementPlacedOrdersCounter],
  );

  // ─────────────────────────────────────────────────────────────────────

  return { handlePostOrderHistory };
};
